import React, {useEffect} from 'react';
import {BrowserRouter, Route} from "react-router-dom";
import CreateCharacter from "./pages/CreateChat/CreateCharacter";
import AuthPage from "./pages/AuthPage/AuthPage";
import ProtectedRoute from "./components/ProtectedRoute/ProtectedRoute";
import SideBar from "./components/layout/Sidebar/SideBar";
import Loader from "./components/layout/Loader/Loader";
import {auth_get_profile} from "./api/auth_api";
import {useProfileStore} from "./store/profile/pofile.store";
import Chats from "./pages/Chats/Chats";
import {toast} from "react-toastify";
import Toaster from "./components/layout/Toaster/Toaster";
import Settings from "./pages/Settings/Settings";
import Terms from "./pages/Terms/Terms";
import Privacy from "./pages/Privacy/Privacy";
import NotFound from "./pages/NotFound/NotFound";
import {authReady, firebase_sign_out, TOKEN_STORAGE_KEY} from "./services/firebase_services";
import {checkEmailVerified} from "./services/verification";
import {SentryRoutes} from "./services/sentry";

function App() {

    const {updateUser, user}: any = useProfileStore();
    const waitingForVerification = Boolean(user) && !user.verified;

    useEffect(() => {
        const fetchProfile = async () => {
            await authReady;
            if (!localStorage.getItem(TOKEN_STORAGE_KEY)) return;
            try {
                const res = await auth_get_profile();
                updateUser(res.data);
            } catch (error) {
                await firebase_sign_out();
                window.open("/auth", "_self");
                toast.error('Session expired');
            }
        };
        fetchProfile();
    }, [updateUser]); // zustand actions are stable, so this still runs once

    // People verify in the email's tab; pick that up when they come back to this one
    useEffect(() => {
        if (!waitingForVerification) return;
        const onVisible = () => {
            if (document.visibilityState !== 'visible') return;
            checkEmailVerified(updateUser).then((verified) => {
                if (verified) toast.success('Email verified, thank you!');
            }).catch(() => {
            });
        };
        document.addEventListener('visibilitychange', onVisible);
        return () => document.removeEventListener('visibilitychange', onVisible);
    }, [waitingForVerification, updateUser]);

    return (
        <BrowserRouter>

            <Toaster/>
            <Loader/>

            <SentryRoutes>
                { /* Public Route */}
                <Route path="/auth" element={<AuthPage type={'login'}/>}/>
                <Route path="/auth/signup" element={<AuthPage type={'signup'}/>}/>
                <Route path="/auth/reset" element={<AuthPage type={'reset'}/>}/>
                <Route path="/auth/action" element={<AuthPage type={'action'}/>}/>
                <Route path="/terms" element={<Terms/>}/>
                <Route path="/privacy" element={<Privacy/>}/>

                { /* Protected Route */}
                <Route path="/" element={
                    <ProtectedRoute>
                        <SideBar pageTitle={'Chats'} variant={'desktop'}>
                            <Chats/>
                        </SideBar>
                    </ProtectedRoute>
                }/>

                <Route path="/create-new-chat" element={
                    <ProtectedRoute>
                        <SideBar pageTitle={'New chat'} variant={'desktop'}>
                            <CreateCharacter/>
                        </SideBar>
                    </ProtectedRoute>
                }/>

                <Route path="/settings" element={
                    <ProtectedRoute>
                        <SideBar pageTitle={'Settings'} variant={'desktop'}>
                            <Settings/>
                        </SideBar>
                    </ProtectedRoute>
                }/>


                { /* Any other address */}
                <Route path="*" element={<NotFound/>}/>
            </SentryRoutes>
        </BrowserRouter>
    );
}

export default App;
